<div id="newsletters" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">College Newsletters</h2>
    <p class="inner-lead mt-3">
      Explore the latest activities, achievements, and events that shape our vibrant campus life. Select a highlight below to learn more.
    </p>

    <hr class="divider">

    <!-- Newsletter Tabs -->
    <div class="newsletter-tabs mt-4">
      <button class="tab-btn" [class.active]="activeTab === 'Inter-College Quiz'" (click)="setActiveTab('Inter-College Quiz')">Inter-College Quiz</button>
      <button class="tab-btn" [class.active]="activeTab === 'Industry Visit'" (click)="setActiveTab('Industry Visit')">Industry Visit</button>
      <button class="tab-btn" [class.active]="activeTab === 'Multidisciplinary Exhibition'" (click)="setActiveTab('Multidisciplinary Exhibition')">Multidisciplinary Exhibition</button>
      <button class="tab-btn" [class.active]="activeTab === 'Educational Visit to Red Cross'" (click)="setActiveTab('Educational Visit to Red Cross')">Educational Visit to Red Cross</button>
      <button class="tab-btn" [class.active]="activeTab === 'Ration Distribution Drive'" (click)="setActiveTab('Ration Distribution Drive')">Ration Distribution Drive</button>
      <button class="tab-btn" [class.active]="activeTab === 'Visit to HDFC Bank'" (click)="setActiveTab('Visit to HDFC Bank')">Visit to HDFC Bank</button>
      <button class="tab-btn" [class.active]="activeTab === 'Seminar on Legal Literacy Cell'" (click)="setActiveTab('Seminar on Legal Literacy Cell')">Seminar on Legal Literacy Cell</button>
      <button class="tab-btn" [class.active]="activeTab === 'Summer Sports Camp'" (click)="setActiveTab('Summer Sports Camp')">Summer Sports Camp</button>
      <button class="tab-btn" [class.active]="activeTab === 'Career Counselling Seminar'" (click)="setActiveTab('Career Counselling Seminar')">Career Counselling Seminar</button>
      <button class="tab-btn" [class.active]="activeTab === 'Industrial Visit to Softwizz'" (click)="setActiveTab('Industrial Visit to Softwizz')">Industrial Visit to Softwizz</button>
    </div>

    <!-- Newsletter Content Area -->
    <div class="newsletter-content-box mt-4">
      <div [ngSwitch]="activeTab">
        
        <div *ngSwitchCase="'Inter-College Quiz'">
          <h4 class="content-title">Inter-College Quiz Contest</h4>
          <p class="content-text">
            On April 12, 2025, a grand Inter-College Quiz Contest was organized by the English Literary Society of Shah Satnam Ji Girls’ College, Sirsa, under the able guidance of Principal Dr. Geeta Monga. The event witnessed enthusiastic participation from teams representing various esteemed colleges affiliated with Chaudhary Devi Lal University. The quiz focused on literature, general knowledge, and current affairs, providing a platform for students to showcase their intellectual prowess.
          </p>
        </div>

        <div *ngSwitchCase="'Industry Visit'">
          <h4 class="content-title">Geography Industrial Visit</h4>
          <p class="content-text">
            Geography Students Gain Practical Insights During Industrial Visit to Kuber Agro-Industry, Moriwala. Students from the Department of Geography, Shah Satnam Ji Girls’ College, Sirsa, undertook an educational industrial visit to the Kuber Agro Industry (Rice Mill) located in Moriwalla on 11th April 2025. This visit aimed to bridge the gap between theoretical knowledge and practical industrial processes.
          </p>
        </div>

        <div *ngSwitchCase="'Multidisciplinary Exhibition'">
          <h4 class="content-title">Grand Multidisciplinary Exhibition</h4>
          <p class="content-text">
            Sirsa, April 12, 2025: A grand multidisciplinary exhibition was organized today at Shah Satnam Ji Girls College, Sirsa, with enthusiastic participation from the departments of Science, Psychology, Home Science, Mathematics, and Computer Science. The exhibition featured innovative projects, working models, and creative displays that highlighted the students' analytical and creative skills across various disciplines.
          </p>
        </div>

        <div *ngSwitchCase="'Educational Visit to Red Cross'">
          <h4 class="content-title">Educational Visit to Red Cross Society</h4>
          <p class="content-text">
            An educational visit to the Red Cross Society was organized by the Public Administration department of Shah Satnam Ji Girls’ College, Sirsa on 9th April 2025. The students were accompanied by faculty members Ms. Geeta Rani and Ms. Jasbir Kaur. Students had the privilege of interacting with Mr. Gurmeet Saini, the assistant secretary of the Red Cross Society, learning about humanitarian services and emergency response mechanisms.
          </p>
        </div>

        <div *ngSwitchCase="'Ration Distribution Drive'">
          <h4 class="content-title">Social Initiative: Ration Distribution</h4>
          <p class="content-text">
            On 8th April 2025, Shah Satnam Ji Girls’ College, Sirsa, in collaboration with the Welfare Works Committee of the college, undertook a noble initiative aimed at extending support to the underprivileged. Essential ration supplies were distributed to an extremely needy family residing in Preet Sagar Colony, Sirsa, embodying the college's commitment to social welfare.
          </p>
        </div>

        <div *ngSwitchCase="'Visit to HDFC Bank'">
          <h4 class="content-title">Educational Trip to HDFC Bank</h4>
          <p class="content-text">
            On 7th April 2025, the Commerce and Management Department of Shah Satnam Ji Girls’ College, Sirsa organized an educational trip to HDFC Bank, Nazia Branch, Sirsa, to provide students with real-world exposure to banking operations. Students learned about various banking services, digital transactions, and customer relationship management.
          </p>
        </div>

        <div *ngSwitchCase="'Seminar on Legal Literacy Cell'">
          <h4 class="content-title">Seminar on Legal Awareness</h4>
          <p class="content-text">
            Under the visionary guidance of Principal Dr. Geeta Monga, the Legal Literacy Cell of Shah Satnam Ji Girls College Sirsa organized a seminar on “Legal Awareness for today’s Woman” on 7th April 2025. The objective was to explain the importance of legal literacy and brief students about their legal rights and protective laws.
          </p>
        </div>

        <div *ngSwitchCase="'Summer Sports Camp'">
          <h4 class="content-title">Summer Sports Camp 2025-26</h4>
          <p class="content-text">
            The Opening of the Summer Sports Camp (Session 2025-26) was held on 7th April 2025. All students who want to participate in various games, athletics, and Yoga Sessions are invited. This Summer Sports Camp is highly beneficial for physical fitness and provides a structured environment for pre-preparation for university-level tournaments.
          </p>
        </div>

        <div *ngSwitchCase="'Career Counselling Seminar'">
          <h4 class="content-title">Communication Skills & Career readiness</h4>
          <p class="content-text">
            In a remarkable step towards enhancing the career readiness of its students, Shah Satnam Ji Girls’ College, Sirsa organized a one-day seminar on April 6, focusing on the importance of communication skills and strategies to improve them in daily life. Experts provided insights into professional etiquette and effective verbal and non-verbal communication.
          </p>
        </div>

        <div *ngSwitchCase="'Industrial Visit to Softwizz'">
          <h4 class="content-title">Industrial Visit to Softwizz Software Company</h4>
          <p class="content-text">
            In a commendable endeavour to bridge academia and industry, Shah Satnam Ji Girls’ College organized an enriching industrial visit to Softwizz Software Company. The visit aimed to provide students with hands-on exposure to real-world corporate environments, focusing on industrial practices, career counselling, and internship opportunities in the IT sector.
          </p>
        </div>

      </div>
    </div>

    <!-- Digital Editions Section (CMS) -->
    <div class="mt-5" *ngIf="cmsNewsletters && cmsNewsletters.length > 0; else noNewsletters">
      <h3 class="title fs-4 mb-3">Download Digital Editions (INSPIRIA)</h3>
      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead class="table-header" style="background: linear-gradient(90deg, var(--primary) 0%, var(--secondary) 100%); color: white;">
            <tr>
              <th style="width: 150px;">Date</th>
              <th>Newsletter Title</th>
              <th style="width: 150px;">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of cmsNewsletters">
              <td class="text-muted">{{ item.dateStr }}</td>
              <td><strong>{{ item.title }}</strong></td>
              <td>
                <a *ngIf="item.pdfUrl" [href]="item.pdfUrl" target="_blank" class="text-primary fw-bold text-decoration-none me-3">
                  Download <i class="fa fa-download small"></i>
                </a>
                <a *ngIf="item.imageUrl" [href]="item.imageUrl" target="_blank" class="text-primary fw-bold text-decoration-none">
                  View Image <i class="fa fa-external-link small"></i>
                </a>
                <span *ngIf="!item.pdfUrl && !item.imageUrl" class="text-muted small">No attachments</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Future PDFs Placeholder (Shows if no CMS data) -->
    <ng-template #noNewsletters>
      <div class="mt-5 p-4 border rounded bg-light text-center">
        <i class="fa fa-info-circle text-primary mb-2 d-block" style="font-size: 2rem;"></i>
        <p class="mb-0 text-muted">Detailed digital editions (PDFs) of our <strong>INSPIRIA</strong> newsletters are currently being compiled and will be available for download soon. Please check back later.</p>
      </div>
    </ng-template>

  </div>
</div>
